import axios from 'axios';

import {
  ARP_PAYMENT_SERVICE_ENDPOINT,
  BOD_PAYMENT_SERVICE_ENDPOINT,
} from '../consts';

const sendRequestToPaymentsService = ({
  auctionId,
  csrfToken,
  propertiesIds,
  onResponse,
  onError,
}) => {
  const payload = { auctionId, propertiesIds };
  axios
    .post(ARP_PAYMENT_SERVICE_ENDPOINT, payload, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'X-CSRFToken': csrfToken,
      },
    })
    .then(onResponse)
    .catch(onError);
};

const sendRequestToPaymentsServiceBod = ({
  bidderId,
  csrfToken,
  onResponse,
  onError,
}) => {
  const payload = { bidderId };
  axios
    .post(BOD_PAYMENT_SERVICE_ENDPOINT, payload, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'X-CSRFToken': csrfToken,
      },
    })
    .then(onResponse)
    .catch(onError);
};

export const requestPaymentsUrlBod = ({
  bidderId,
  csrfToken,
  onResponse = () => {},
  onError = () => {},
}) => {
  sendRequestToPaymentsServiceBod({
    bidderId,
    csrfToken,
    onResponse,
    onError,
  });
};

export const requestPaymentsUrl = ({
  auctionId,
  csrfToken,
  propertiesIds,
  onResponse = () => {},
  onError = () => {},
}) => {
  sendRequestToPaymentsService({
    auctionId,
    csrfToken,
    propertiesIds,
    onResponse,
    onError,
  });
};
